import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { TasksService } from '@app/shared/services/tasks/tasks.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-add-task-rule',
  templateUrl: './dialog-add-task-rule.component.html',
  styleUrls: ['./dialog-add-task-rule.component.scss'],
})
export class DialogAddTaskRuleComponent implements OnInit {
  creating: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogAddTaskRuleComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private taskService: TasksService,
    public authService: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit() { }

  dismissModal() {
    this.dialogRef.close();
  }

  createTaskRule(taskType: number, time: number, relativeTo: string) {
    this.creating = true;

    this.taskService.createTaskRule(taskType, time, relativeTo).subscribe(
      (res) => {
        this.creating = false;

        if (res.data) {
          this.router.navigate(['/operations/task-rules/task/' + res.data.uuid]);
          this.dialogRef.close();
        }
      },
      (err) => {
        this.creating = false;
      }
    );
  }
}
